import peerConnectSound from '@assets/audio/peer_connect.mp3';
import peerDisconnectSound from '@assets/audio/peer_disconnect.mp3';
import peerRequestSound from '@assets/audio/peer_request.mp3';
import peerWaitingSound from '@assets/audio/peer_waiting.mp3';
import selfConnectSound from '@assets/audio/self_connect.mp3';
import selfDisconnectSound from '@assets/audio/self_disconnect.mp3';
import { useLocalMediaStore } from '@stores/call/localMediaStore';
import { defineStore } from 'pinia';

export const useCallAudioStore = defineStore('callAudio', () => {
  const localMediaStore = useLocalMediaStore();

  const selfConnectAudio = new Audio(selfConnectSound);
  const selfDisconnectAudio = new Audio(selfDisconnectSound);
  const peerConnectAudio = new Audio(peerConnectSound);
  const peerDisconnectAudio = new Audio(peerDisconnectSound);
  const peerWaitingAudio = new Audio(peerWaitingSound);
  const peerRequestAudio = new Audio(peerRequestSound);

  const playAudio = (audio: HTMLAudioElement) => {
    if (!localMediaStore.isGlobalAudioMuted) {
      audio.play();
    }
  };

  return {
    selfConnectAudio,
    selfDisconnectAudio,
    peerConnectAudio,
    peerDisconnectAudio,
    peerWaitingAudio,
    peerRequestAudio,
    playAudio,
  };
});
